import axios from 'axios';
/* istanbul ignore file */
const state = {
  drawer: false,
  mini: false,
};
const mutations = {
  setDrawer(st, drawer) {
    st.drawer = drawer;
  },
  setMini(st, mini) {
    st.mini = mini;
  },
};
const getters = {
  globalMenu() {
    return [
      // { title: 'Contato', icon: 'mdi-email', to: { name: 'ContactsAdd' } },
      // { title: 'Mensagens', icon: 'mdi-forum' },
    ];
  },
  userMenu(st, gt, rSt) {
    const allowedMenuItems = ({ featureId }) => {
      const { currentUser, currentAccount, featuresAccounts } = rSt.session;

      // menuItem without feature is always allowed
      if (!featureId) return true;

      // does not allow anything until login
      if (!currentUser || !currentAccount || !featuresAccounts) return false;

      const featuresAccountAllowed = featuresAccounts.data.find(
        ({ id }) => id === currentAccount.id,
      );
      
      return featuresAccountAllowed
        .features
        .some(feature => feature.id === featureId);
    };
    return [
      {
        title: 'Contato',
        icon: 'mdi-email', 
        featureId: 7,
        to: { name: 'ContactsAdd' } 
      },
      {
        title: 'Notificações',
        icon: 'mdi-bell',
        featureId: 13,
        to: { name: 'Notifications' },
      },
      {
        title: 'Estatísticas',
        icon: 'mdi-equalizer',
        featureId: 9,
        to: { name: 'Dashboard' },
      },
      {
        title: 'NFs e Boletos',
        icon: 'mdi-barcode',
        featureId: 1,
        to: { name: 'invoices' },
      },
      {
        title: 'Documentos',
        icon: 'mdi-file-document',
        featureId: 3,
        to: { name: 'Documents' },
      },
      {
        title: 'Segurança Eletrônica',
        icon: 'mdi-shield-check',
        featureId: 10,
        to: { name: 'AlarmsList' },
      },
      {
        title: 'Solicitações',
        icon: 'mdi-alert-circle',
        featureId: 7,
        to: { name: 'ContactsList' },
      },
      // Disabled due Design QA
      // {
      //   title: 'Meu Perfil',
      //   icon: 'mdi-account',
      //   to: { name: 'Profile' },
      // },
      {
        title: 'Controle de usuários',
        icon: 'mdi-account-group',
        featureId: 2,
        to: { name: 'GuestsList' },
      },
    ].filter(allowedMenuItems);
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
